import React from 'react';
import PropTypes from 'prop-types';
import { Row } from '../structure/row';
import { Cell, LEFT, RIGHT } from '../structure/cell';
import { noop } from '../../../../../lib/utilities';

export const RowTwoCells = ({
    name,
    isSub,
    hasBorder,
    noBottomPadding,
    hasPaddingBottom,
    left,
    right,
    middle,
    colspan,
    onComponentClick,
}) => (
    <Row
        className={name}
        isSub={isSub}
        hasBorder={hasBorder}
        hasPaddingBottom={hasPaddingBottom}
        onComponentClick={onComponentClick}
    >
        <Cell noBottomPadding={noBottomPadding} key={name} side={LEFT} colSpan={colspan ? colspan : right ? 1 : 2}>
            {left}
        </Cell>

        {middle !== false && <Cell noBottomPadding={noBottomPadding} side={RIGHT}>
            {middle || ''}
        </Cell>}
        
        {right && <Cell noBottomPadding={noBottomPadding} side={RIGHT}>
            {right}
        </Cell>}
    </Row>
);

const extraChildrenPropType = PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
]);

RowTwoCells.propTypes = {
    name: PropTypes.string.isRequired,
    left: extraChildrenPropType.isRequired,
    isSub: PropTypes.bool,
    hasBorder: PropTypes.bool,
    noBottomPadding: PropTypes.bool,
    hasPaddingBottom: PropTypes.bool,
    onComponentClick: PropTypes.func,
};

RowTwoCells.defaultProps = {
    isSub: false,
    hasBorder: true,
    noBottomPadding: false,
    hasPaddingBottom: true,
    onComponentClick: noop,
};
